import * as React from "react";

const LinkIcon = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" {...props}>
    <path
      fill="#64748B"
      d="M10.354 5.646a.5.5 0 0 1 0 .708l-4 4A.499.499 0 0 1 5.5 10a.5.5 0 0 1 .146-.354l4-4a.5.5 0 0 1 .708 0Zm3.121-3.12a3.5 3.5 0 0 0-4.95 0L6.646 4.402a.5.5 0 1 0 .708.708l1.879-1.875a2.5 2.5 0 0 1 3.535 3.535l-1.88 1.879a.5.5 0 0 0 .708.707l1.88-1.882a3.5 3.5 0 0 0 0-4.95Zm-4.829 8.363-1.878 1.879a2.502 2.502 0 0 1-4.1-.798 2.5 2.5 0 0 1 .565-2.738L5.11 7.354a.5.5 0 1 0-.708-.708l-1.878 1.88a3.5 3.5 0 1 0 4.95 4.95l1.879-1.88a.5.5 0 0 0-.708-.707Z"
    />
  </svg>
);
export default LinkIcon;
